import React, { useMemo, useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import axios from "axios";

import { request } from "../../api";

import styles from "./CitySelection.module.scss";

const CitySelection = ({ close, setCity }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setloading] = useState(true);

  useEffect(() => {
    if (!data && !error) {
      axios
        .get(`${request}/api/get-contacts`)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [data, error, request]);
  
  const { register, control } = useForm();

  const inputValue = useWatch({
    control,
    defaultValue: "",
    name: "city",
  });

  const sortAlphabetically = (a, b) => {
    const firstCity = a.city.toLowerCase();
    const secondCity = b.city.toLowerCase();

    if (firstCity < secondCity) {
      return -1;
    } else if (firstCity > secondCity) {
      return 1;
    } else {
      return 0;
    }
  };

  const filteredCityList = useMemo(() => {
    return data
      ? data.contacts.sort(sortAlphabetically).filter((city) => {
          const regex = new RegExp(inputValue.trim(), "gi");

          return city.city.match(regex);
        })
      : [];
  }, [data, inputValue]);

  const handleClick = (city) => {
    console.log(`Выбран город: ${city}`);
    axios
      .post(`${request}/api/set-contact`, {
        city: city,
      })
      .then(
        (result) => {
          if (result.data.message === "success") {
            if (result.data.city_path) {
              if (
                window.location.host !== "staging.proektmarketing.ru" &&
                window.location.host !== "proektmarketing.ru" &&
                window.location.hostname !== "localhost"
              ) {
                let old_city = window.location.host.split(".")[0];
                let re = new RegExp(old_city, "g");
                let new_url = window.location.href.replace(
                  re,
                  result.data.city_path
                );
                window.location.replace(new_url);
              } else {
                let cur_path = window.location.pathname;
                let cur_path_with_city;
                if (
                  ["services", "projects", "about", "contacts"].findLast((e) =>
                    e.includes(window.location.pathname.split("/")[1])
                  )
                ) {
                  cur_path_with_city = `/${result.data.city_path}${window.location.pathname}`;
                } else {
                  let old_city = window.location.pathname.split("/")[1];
                  let re = new RegExp(old_city, "g");
                  cur_path_with_city = window.location.pathname.replace(
                    re,
                    result.data.city_path
                  );
                }
                window.history.replaceState({}, cur_path, cur_path_with_city);
              }
            }

            setCity(result.data.city_path);
            close();
            // TODO: установить значение города, закрыть модальное окно
          } else {
            console.log(result);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  return (
    <div className={styles.CitySelection}>
      <div className={styles.Wrapper}>
        <input
          className={styles.Input}
          type="text"
          {...register("city")}
          placeholder="Введите название города"
        />

        <div className={styles.Container}>
          <ul className={styles.List}>
            {!loading && error && <p>Извините что-то пошло не так</p>}
            {!loading && !error && filteredCityList.length === 0 && (
              <p>По вашему запросу ничего не найдено</p>
            )}
            {loading && <p>Загрузка...</p>}

            {filteredCityList.map((city) => {
              return (
                <li key={city.id} className={styles.Item}>
                  <button
                    className={styles.City}
                    onClick={() => {
                      handleClick(city.city);
                    }}
                  >
                    {city.city}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CitySelection;
